function ApplySelectionLimits(element) {
    if (element) {
        element.selectize({
            plugins: ['remove_button'],
            maxItems: !element.data("limit") ? null : parseInt(element.data("limit"))
        });
    }
}

function ClearInput(index, input) {
    input = $(input);
    if (input && input[0].selectize) {
        input[0].selectize.clear();
    }
    else {
        if (input.is(':checkbox')) {
            input.prop('checked', false);
        }
        else if (input.is(':hidden')) {            
            input.closest('.custom-field-file').remove();
            var customFieldID = input.attr('name').split('_')[1];
            var fileUploaderButton = $(`[data-custom-field-id='${customFieldID}']`);
            var singleUploadButton = fileUploaderButton.siblings(".file-input-label-single");
            if (singleUploadButton.length) {
                singleUploadButton.html(singleUploadButton.html().replace("Replace", "Upload"));
            } else {
                var multiUploadButton = fileUploaderButton.siblings(".file-input-label-multiple");
                if (multiUploadButton.length) {
                    multiUploadButton.html(multiUploadButton.html().replace("Additional", ""));
                }
            }
        } 
        else {
            input.val("");
        }
    }
}

function isSuggestedFieldInfoMissing() {
    var infoMissing = false;
    $("input.suggested, select.suggested").not("[name*='_number_']").each(function () {
        if (!infoMissing && ($(this).val() == null || $(this).val() === "")) {
            infoMissing = true;
        }
    });
    return infoMissing;
}

function GetCustomFieldValues(baseElement, includeFalseValues = false) {

    var customFieldValues = {};
    baseElement.find($('[id*="CustomField"]')).each(function () {

        var val;
        if ($(this).is(":checkbox")) {
            val = $(this).is(":checked");
        }
        else {
            val = $(this).val();
        }

        // Multi Select Custom Fields
        if (Array.isArray(val)) {
            val = val.join(";");
        }

        if (!val && !includeFalseValues) {
            return;
        }

        var htmlId = $(this).attr("id");
        var customFieldId = htmlId.substring(htmlId.indexOf("CustomField_") + 12);

        customFieldValues[customFieldId] = {
            CustomFieldId: customFieldId,
            Value: val
        };
    });


    var groupedCustomFieldFiles = [];
    baseElement.find($('[name*="CustomFieldFile"]')).each(function () {

        var val;
        val = $(this).val();
        console.log(val)

        if (!val && !includeFalseValues) {
            return;
        }

        var id = $(this).attr('name').split('_')[1];

        if (!groupedCustomFieldFiles[id]) {
            groupedCustomFieldFiles[id] = [];
        }

        var fileVal = $(this).prop('defaultValue');

        if (fileVal) {
            groupedCustomFieldFiles[id].push(JSON.parse(decodeURIComponent(fileVal)));
        }
    });

    for (var index in groupedCustomFieldFiles) {
        var element = groupedCustomFieldFiles[index];

        customFieldValues[index] = {
            CustomFieldId: index,
            Value: JSON.stringify(element)
        };
    }

    return customFieldValues;
}

$(function () {
    $(".selectized[name*='CustomField_']").not(".required").on("change", function () {
        var select = $(this);
        var selectId = select.attr("id");
        var numOptionsSelected = select[0].options.length;

        if (numOptionsSelected === 0) {
            select.before("<input type='hidden' value='' name='" + selectId + "'>");
        }
        else {
            $("input[name=" + selectId + "]").remove();
        }
    });

    if (jQuery.validator && jQuery.validator.addMethod) {
        jQuery.validator.addMethod("dangerContent", function (value, element) {
            var forbiddenChars = ['<', '>']
            var curentContent = value;

            if (!$(element).hasClass('prevent-danger-content')) {
                return true;
            }

            return forbiddenChars.filter(function (val) { return curentContent.indexOf(val) > -1 }).length == 0;

        }, "Value cannot contain '<' or '>'.");

        if ($.fn.validate) {
            $('form .prevent-danger-content').each(function () { $(this).rules("add", "dangerContent"); })
        }
    }
});



$(() => {
    var list = $(".has-nested-field");

    $.each(list, (i, val) => {
        $(val).on('change', checkForToggleValue);
    });

    const observer = new MutationObserver((mutations) => {
        var list = $(".has-nested-field");
        $.each(list, (i, val) => {
            $(val).on('change', checkForToggleValue);
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Initial visibility + sibling order from current parent selection
    $(".has-nested-field").each(function () {
        $(this).trigger('change');
    });

    function resolveSelectedOrder(selectedVal) {
        var order = [];
        if (typeof selectedVal === 'object' && selectedVal && selectedVal.length) {
            for (var i = 0; i < selectedVal.length; i++) {
                var v = String(selectedVal[i]).trim();
                if (v) {
                    order.push(v);
                }
            }
        } else if (typeof selectedVal === 'string' && selectedVal.indexOf(';') >= 0) {
            var parts = selectedVal.split(';');
            for (var j = 0; j < parts.length; j++) {
                var p = parts[j].trim();
                if (p) {
                    order.push(p);
                }
            }
        } else if (selectedVal != null && selectedVal !== '') {
            order.push(String(selectedVal).trim());
        }
        return order;
    }

    function reorderNestedFieldSiblings($nestedFields, selectedVal) {
        if (!$nestedFields || $nestedFields.length === 0) {
            return;
        }
        var order = resolveSelectedOrder(selectedVal);
        var sentinel = 100000;
        function triggerRank(trigger) {
            var t = String(trigger || '').trim();
            var idx = order.indexOf(t);
            return idx === -1 ? sentinel : idx;
        }
        var arr = $nestedFields.toArray();
        arr.sort(function (a, b) {
            var ra = triggerRank($(a).data('trigger-value'));
            var rb = triggerRank($(b).data('trigger-value'));
            if (ra !== rb) {
                return ra - rb;
            }
            var depA = parseInt($(a).attr('data-dependency-display-order'), 10);
            var depB = parseInt($(b).attr('data-dependency-display-order'), 10);
            if (isNaN(depA)) {
                depA = 0;
            }
            if (isNaN(depB)) {
                depB = 0;
            }
            if (depA !== depB) {
                return depA - depB;
            }
            var da = parseInt($(a).attr('data-display-order'), 10);
            var db = parseInt($(b).attr('data-display-order'), 10);
            if (isNaN(da)) {
                da = 0;
            }
            if (isNaN(db)) {
                db = 0;
            }
            if (da !== db) {
                return da - db;
            }
            var ida = parseInt(a.id, 10) || 0;
            var idb = parseInt(b.id, 10) || 0;
            return ida - idb;
        });
        var parent = $(arr[0]).parent();
        arr.forEach(function (el) {
            parent.append(el);
        });
    }

    function getParentSelectValue(el) {
        if (el && el.selectize) {
            return el.selectize.getValue();
        }
        return $(el).val();
    }

    function checkForToggleValue(e) {
        var selectedVal = getParentSelectValue(e.target);
        var id = $(e.target).attr('id');
        if (id) {
            var splitID = id.split('_');
            var customFieldID = splitID[splitID.length - 1];
            var nestedFields = $(e.target).siblings(`.${customFieldID}-nested-field`);

            $.each(nestedFields, (i, val) => {
                var toggleValue = $(val).data('trigger-value');
                let hasTriggerValue = false;
                if (typeof selectedVal === 'object' && selectedVal && selectedVal.length) {
                    hasTriggerValue = selectedVal.includes(toggleValue);
                } else {
                    hasTriggerValue = selectedVal == toggleValue;
                }
                $(val).toggleClass('hidden', !hasTriggerValue);
                if (!hasTriggerValue) {
                    var nestedInputs = $(val).find('.nested-input');

                    $.each(nestedInputs, (i, input) => {
                        var $input = $(input);
                        if ($input.is(':checkbox')) {
                            $input.prop('checked', false).val('true');
                        } else {
                            $input.val('');
                            $input.prop('defaultValue', '');
                        }
                    });

                    deleteNestedCustomFieldFiles(val);
                }
            });
            reorderNestedFieldSiblings(nestedFields, selectedVal);
        }
    }

    function deleteNestedCustomFieldFiles(nestedField) {
        var files = $(nestedField).find('.remove-custom-file');
        $.each(files, (i, file) => {
            deleteFile(file);
        });
    }
});

